export const PACKAGE_VERSION = '0.6.0';
//# sourceMappingURL=package-version.js.map